import {
  Container,
  Stack,
  Button,
  MenuItem,
  styled,
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { selectActiveSession } from "app/modules/schools/selectors";
import {
  deleteCollectionSubHead,
  getAllCollectionHead,
  getAllCollectionSubHead,
} from "app/services/ledgerAccount";
import { MenuProps } from "app/utils/helper";
import { CustomSelectBox } from "assets/styles/globalStyledComponent";
import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CustomLoader from "app/components/common/CustomLoader";
import { queryClient } from "App";
import DialogHeader from "app/components/common/DialogHeader";

import * as XLSX from "xlsx";
import { format } from "date-fns";
import CommonTable1 from "app/components/Tables/CommonTable1";
import AddCollectionSubHead from "app/components/common/Dialogs/AddCollectionSubHead";
import ExportButtonGroup from "app/components/common/ExportButtonGroup";
import appRoutes from "app/config/routes";
import TableActionButtons from "app/components/common/TableActionButtons";
import DeleteDialog from "app/components/ConfirmationDialog/DeleteDialog";
import AddNewCollectionDialog from "app/components/common/Dialogs/ledger/collection/AddNewCollectionDialog";

const SubHeadsPage = ({ id }) => {
  const selectedSession = useSelector(selectActiveSession);
  const [state, setState] = useState({
    sub: id,
    tableData: null,
  });

  const formatDate = (data) => {
    const date = new Date(data);
    return format(date, "yyyy-MM-dd");
  };

  const [dialogs, setDialogs] = useState({
    collection: false,
    headName: id,
    subHead: "",
    add: false,
    export: false,
    collectionSubHeadDelete: false,
    collectionSubHeadId: "",
  });

  const {
    isLoading,
    isFetching,
    refetch: getAllCollectionSubHeadRefetch,
  } = useQuery({
    queryKey: "getAllCollectionSubHead",
    queryFn: () =>
      getAllCollectionSubHead({
        collectionHeadDocId: id,
        withAmount: "YES",
        session: selectedSession,
      }),
    onSuccess: (res) => {
      setState((prev) => ({ ...prev, tableData: res?.data?.list }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });

  useQuery({
    queryKey: "getAllCollectionHead",
    queryFn: getAllCollectionHead,
    onSuccess: (res) => {
      setState((prev) => ({
        ...prev,
        heads: res?.data?.list?.map((item) => ({
          id: item._id,
          name: item.collectionHeadName,
        })),
      }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });
  const handleDelete = (data) => {
    setDialogs((prev) => ({
      ...prev,
      collectionSubHeadDelete: true,
      collectionSubHeadId: data?.id,
    }));
  };

  const { mutate: getAllCollectionSubHeadMutate } = useMutation(
    getAllCollectionSubHead,
    {
      onSuccess: (res) => {
        setState((prev) => ({ ...prev, tableData: res?.data?.list }));
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message);
      },
    }
  );
  const {
    mutate: deleteCollectionSubHeadMutate,
    isLoading: deleteCollectionSubHeadLoading,
  } = useMutation(deleteCollectionSubHead, {
    onSuccess: (res) => {
      toast.success(res?.data?.message);
      setDialogs((prev) => ({
        ...prev,
        collectionSubHeadDelete: false,
        collectionSubHeadId: "",
      }));
      getAllCollectionSubHeadRefetch();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const columns = [
    {
      header: "Sr.No",
      Cell: ({ cell }) => (
        <Typography>
          {parseInt(cell?.row?.id) < 9
            ? `0${parseInt(cell?.row?.id) + 1}`
            : parseInt(cell?.row?.id) + 1}
        </Typography>
      ),
      size: 30,
    },

    {
      header: "Sub Head Name",
      accessorKey: "subhead",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.sub}</Typography>;
      },
      size: 60,
    },
    {
      header: "Description",
      accessorKey: "desc",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original.desc}</Typography>;
      },
      size: 70,
    },
    {
      header: "Amount",
      accessorKey: "amt",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Stack direction={"row"} gap={1}>
            <Link
              to={`/${appRoutes.collections}?head=${id}&subhead=${original?.id}`}
            >
              {original.amt}
            </Link>
            <Typography
              sx={{
                color: "blue",
                fontStyle: "italic",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() =>
                setDialogs((prev) => ({
                  ...prev,
                  collection: true,
                  subHead: original?.id,
                }))
              }
            >
              +Add more
            </Typography>
          </Stack>
        );
      },
      size: 40,
    },
    {
      header: "Created By",
      accessorKey: "by",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original.by}</Typography>;
      },
      size: 50,
    },
    {
      header: "Action",
      maxSize: 50,
      Cell: ({ cell }) => {
        return (
          <TableActionButtons
            showDelete
            handleDelete={() => handleDelete(cell?.row?.original)}
          />
        );
      },
    },
  ];

  const tableData = state?.tableData?.map((item) => ({
    id: item._id,
    head: item?.collectionHeadDetail?.collectionHeadName || "--",
    sub: item?.collectionSubHeadName || "--",
    desc: item?.description || "--",
    amt: item?.totalAmount || "--",
    by: item?.createdBy?.personName || "--",
  }));

  let exportArray = state.tableData?.map((item) => {
    return {
      Collection_Head_Name:
        item?.collectionHeadDetail?.collectionHeadName || "",
      Head_Description: item?.collectionHeadDetail?.description || "",
      Updated_By: item?.collectionHeadDetail?.updatedBy?.personName || "",
      Updated_On: item?.collectionHeadDetail?.updatedOn
        ? formatDate(item?.collectionHeadDetail?.updatedOn)
        : "",
      Updated_Times: item?.collectionHeadDetail?.updatedTimes || 0,
      Collection_Sub_Head_Name: item?.collectionSubHeadName || "",
      Created_By: item?.createdBy?.personName || "",
      Created_On: item?.createdOn ? formatDate(item?.createdOn) : "",
      Description: item?.description || "",
      Total_Amount: item?.totalAmount || 0,
    };
  });

  let header = [
    "Collection_Head_Name",
    "Head_Description",
    "Updated_By",
    "Updated_On",
    "Updated_Times",
    "Collection_Sub_Head_Name",
    "Created_By",
    "Created_On",
    "Description",
    "Total_Amount",
  ];

  const [selectedOptions, setSelectedOptions] = useState(header);

  const handleExport = () => {
    const filteredExportArray = exportArray.map((item) => {
      const filteredItem = {};
      selectedOptions.forEach((option) => {
        filteredItem[option] = item[option];
      });
      return filteredItem;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredExportArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "All Collections");
    XLSX.writeFile(workbook, "Collections.xlsx");
  };

  const handleCheckboxChange = (option, isChecked) => {
    if (isChecked) {
      setSelectedOptions((prevSelectedOptions) => [
        ...prevSelectedOptions,
        option,
      ]);
    } else {
      setSelectedOptions((prevSelectedOptions) =>
        prevSelectedOptions.filter(
          (selectedOption) => selectedOption !== option
        )
      );
    }
  };

  const handleCloseDeleteCollectionDialog = () => {
    setDialogs((prev) => ({
      ...prev,
      collectionSubHeadDelete: false,
    }));
  };

  const handledeleteCollectionHead = () => {
    deleteCollectionSubHeadMutate(dialogs.collectionSubHeadId);
  };

  return (
    <>
      {/* other collection detail dialog */}
      <AddNewCollectionDialog
        dialogs={dialogs}
        setDialogs={setDialogs}
        refetch={() => getAllCollectionSubHeadRefetch()}
      />
      {/* add sub collection sub head */}
      <AddCollectionSubHead
        open={dialogs.add}
        handleClose={() => {
          setDialogs((prev) => ({ ...prev, add: false }));
        }}
        headId={id}
        refetch={() => getAllCollectionSubHeadRefetch()}
      />
      <CustomLoader show={isFetching || isLoading} />

      {/* Delete Dialog Confirmation of Collection*/}
      <DeleteDialog
        open={dialogs.collectionSubHeadDelete}
        handleClose={handleCloseDeleteCollectionDialog}
        handleDelete={handledeleteCollectionHead}
        loading={deleteCollectionSubHeadLoading}
      />
      {/* export dialog */}
      <Dialog
        open={dialogs.export}
        onClose={() =>
          setDialogs((prev) => ({
            ...prev,
            export: false,
          }))
        }
        PaperProps={{
          sx: { minWidth: "400px" },
        }}
      >
        <DialogHeader
          title="Select Information to export"
          handleClose={() =>
            setDialogs((prev) => ({
              ...prev,
              export: false,
            }))
          }
        />
        <DialogContent>
          <Box>
            {header.map((option) => (
              <Stack direction="row">
                <FormControlLabel
                  key={option}
                  control={
                    <Checkbox
                      checked={selectedOptions.includes(option)}
                      onChange={(e) =>
                        handleCheckboxChange(option, e.target.checked)
                      }
                    />
                  }
                  label={option}
                />
              </Stack>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            sx={{ mb: 1 }}
            onClick={() => {
              setSelectedOptions(header);
              handleExport();
              setDialogs((prev) => ({
                ...prev,
                export: false,
              }));
            }}
          >
            DownLoad
          </Button>
        </DialogActions>
      </Dialog>
      <Container maxWidth="xl">
        <Stack gap={2} p={2}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <CustomSelectBox
              displayEmpty
              sx={{ width: "15rem" }}
              size="medium"
              MenuProps={MenuProps}
              value={state?.sub}
              onChange={(e) => {
                setState((prev) => ({ ...prev, sub: e.target.value }));
                getAllCollectionSubHeadMutate({
                  collectionHeadDocId: e.target.value,
                  withAmount: "YES",
                  session: selectedSession,
                });
              }}
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {state?.heads?.map((item) => (
                <MenuItem value={item.id}>{item.name}</MenuItem>
              ))}
            </CustomSelectBox>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => {
                  // getAllCollectionHeadQ()
                  queryClient.invalidateQueries({
                    queryKey: "getAllCollectionHead",
                  });
                  setDialogs((prev) => ({ ...prev, add: true }));
                }}
              >
                + Add New Sub Head
              </Button>
              <ExportButtonGroup
                showExcel
                showPdf={false}
                handleClickExcel={() =>
                  setDialogs((prev) => ({ ...prev, export: true }))
                }
              />
            </Stack>
          </Stack>

          {/* <Table columns={columns} data={tableData || []} /> */}
          <CommonTable1
            columns={columns}
            data={tableData || []}
            maxHeight="70vh"
          />
        </Stack>
      </Container>
    </>
  );
};

export default SubHeadsPage;

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  lineHeight: "1.4rem",
  fontWeight: 600,
  color: "#0C2F49",
}));

const Label = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  lineHeight: "1.2rem",
  marginBottom: "10px",
  fontWeight: 600,
  color: "#0C2F49",
}));
